
// Helper function to parse date string safely (YYYY-MM-DD format)
export const parseDateFromUrl = (dateString: string): Date | null => {
  if (!dateString) return null;
  
  // Split the date string to avoid timezone issues
  const [year, month, day] = dateString.split('-').map(Number);
  if (!year || !month || !day) return null;
  
  // Create date in local timezone (month is 0-indexed)
  const date = new Date(year, month - 1, day);
  return isNaN(date.getTime()) ? null : date;
};

// Calculate nights between two dates
export const calculateNights = (checkInDate: Date, checkOutDate: Date): number => {
  const timeDiff = checkOutDate.getTime() - checkInDate.getTime();
  return Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
};

// Format price with currency
export const formatPrice = (amount: number): string => {
  return `$${amount.toLocaleString()} MXN`;
};
